import { useMemo } from 'react'
import { useQueryParams } from '@fs/zion-router'
import { useImageOrganizeModes, useGroupData } from '../../../views/imageBrowse/hooks'
import useViewMode from '../../../views/imageBrowse/hooks/useViewMode'

export default function useImageBrowserGroup() {
  const { viewMode } = useViewMode()
  const { query } = useQueryParams()
  const { isDivideMode } = useImageOrganizeModes()
  const { initialGroup, group: currentChildGroup } = useGroupData()
  const group = useMemo(() => {
    // If cat param is present, always use the initial group (full group view)
    // This ensures thumbnails are initialized correctly on first render
    if (query?.cat) {
      return initialGroup
    }
    return isDivideMode || viewMode === 'group' ? initialGroup : currentChildGroup
  }, [initialGroup, currentChildGroup, isDivideMode, viewMode, query?.cat])

  return group
}
